module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input-group-sm"
  }, [_c('select', {
    staticClass: "form-control",
    attrs: {
      "title": _vm.item.desc
    },
    on: {
      "change": function($event) {
        return _vm.changeselect($event)
      }
    }
  }, _vm._l((_vm.item.value), function(sitem, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(sitem.desc))])
  }), 0), _vm._v(" "), _vm._l((_vm.item.value), function(sitem) {
    return [(sitem.type == 'number' && sitem.hidden != true) ? _c('my-component-number', {
      attrs: {
        "item": sitem
      }
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1ecb5cd6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vue/select.vue
// module id = 91
// module chunks = 0